import Icon from '../components/Icon.vue'

Icon.register({"dice-five":{"width":448,"height":512,"paths":[{"d":"M384 32H64C28.6 32 0 60.6 0 96V416C0 451.4 28.6 480 64 480H384C419.4 480 448 451.4 448 416V96C448 60.6 419.4 32 384 32zM128 384C110.3 384 96 369.7 96 352S110.3 320 128 320 160 334.3 160 352 145.7 384 128 384zM128 192C110.3 192 96 177.7 96 160S110.3 128 128 128 160 142.3 160 160 145.7 192 128 192zM224 288C206.3 288 192 273.7 192 256S206.3 224 224 224 256 238.3 256 256 241.7 288 224 288zM320 384C302.3 384 288 369.7 288 352S302.3 320 320 320 352 334.3 352 352 337.7 384 320 384zM320 192C302.3 192 288 177.7 288 160S302.3 128 320 128 352 142.3 352 160 337.7 192 320 192z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dice-five.js
// module id = PLM3
// module chunks = 0